module.exports = {
	"root": "findify-components--facet",
	"title": "findify-components--facet__title",
	"text": "findify-components--facet__text",
	"icon": "findify-components--facet__icon",
	"body": "findify-components--facet__body"
};